//
//
//
//
//
//

export default {
  props: {
    rows: {
      type: Number,
      default: 3
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/grid/grid.vue